import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import DateTimeField from 'react-bootstrap-datetimepicker';
import moment from 'moment';
import Select from 'react-select';
import cities_list from './utils/cities_list';
import states_list from './utils/states_list';
import _ from 'lodash';

import {
  ToggleSwitch,
  Checkbox
 } from 'components';

class MapForm extends React.Component {
  constructor(props) {
    super(props);

    this.displayName = 'MapForm';
    this.handleChange = this.handleChange.bind(this);
    this.handleStateSelect = this.handleStateSelect.bind(this);
    this.handleStormDateChange = this.handleStormDateChange.bind(this);
    this.handlePublishDateChange = this.handlePublishDateChange.bind(this);
    this.handleMapTypeSelect = this.handleMapTypeSelect.bind(this);
    this.handleEventTagsSelect = this.handleEventTagsSelect.bind(this);
    this.handleCitySelect = this.handleCitySelect.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.selectors = [];

    this.state = {
      errors : {
        storm_date : false,
        publish_date : false
      }
    }
  }
  handleMapTypeSelect(value) {
    this.setState(state => ({
      ...state,
      properties: {
        ...state.properties,
        mapType: value,
      },
    }));
  }
  handleEventTagsSelect(value) {
    this.setState(state => ({
      ...state,
      properties: {
        ...state.properties,
        eventTags: value,
      },
    }));
  }
  handleStateSelect(result) {
    this.setState({
      properties: {
        ...this.state.properties,
        states: result.map(r => r.value)
      }
    });
  }
  handleCitySelect(result) {
    this.setState({
      properties: {
        ...this.state.properties,
        cities: result.map(r => r.value)
      }
    });
  }
  handleChange(event) {
  	const state = { ...this.state.properties };
    let item = state;
    let value = event.target.value;
    let keys = event.target.name;

    //Checkboxes
    if(event.target.type == 'checkbox') {
      value = event.target.checked;
    }

    keys = keys.split('.');
    var iterations = keys.length - 1;
    for (var i = 0; i < iterations; i++) {
      item = item[keys.shift()];
    };
    switch(event.target.name) {
      case 'price':
        var val = value.match(/^[0-9]*$/g);
        if(val) {
          item[keys[0]] = val.join('');
        }
        break;
      case 'max_hail_size':
       item[keys[0]] = (value.match(/[0-9]*\.?([0-9]+)?/g))[0];
       break;
      case 'hail_duration':
        if(!isNaN(Number(value)))
          item[keys[0]] = Number(value);
        break;
      default:
        item[keys[0]] = value;
        break;
    }
    this.setState({ properties: { ...this.state.properties, ...state } });
  }
  handleStormDateChange(storm_date) {
    var bool = storm_date == "Invalid date" ? true : false;
    var errors = Object.assign({},this.state.errors,{
      storm_date : bool
    });
    if(!bool) {
      const [ month, day, year ] = storm_date.split('/').filter(e => e);
      storm_date = new Date(`${year}-${month}-${day}T12:00:00.000Z`);
    }
    this.setState({
      errors,
      properties: {
        ...this.state.properties,
        storm_date
      }
    });
  }
  handlePublishDateChange(publish_date) {
    var bool = publish_date == "Invalid date"? true : false;
    var errors = Object.assign({},this.state.errors,{
      publish_date : bool
    });
    if(!bool) {
      const [ month, day, year ] = publish_date.split('/').filter(e => e);
      publish_date = new Date(`${year}-${month}-${day}T12:00:00.000Z`);
    }
    this.setState({
      errors,
      properties: {
        ...this.state.properties,
        publish_date
      }
    });
  }
  handleSave() {
    const updated_map = { ...this.props.map, properties: this.state.properties };
    this.props.handleSave(updated_map);
  }

  componentWillMount() {
    this.setState({ properties: this.props.map.properties });
  }
  render() {
      const { properties: map_properties } = this.state;
      var errors = this.state.errors;
      if(map_properties) {
        return (
          <div className='panel panel-primary mb-none'>
            <div className='panel-heading'>
              <h3 className='panel-title'>{this.props.totle}</h3>
            </div>
            <div className='panel-body'>
              <div className='row'>
                <div className='col-xs-12'>
                  <form className="form mb-lg">
                    <div className="form-group">
                      <div className="row mb-sm">
                        <div className="col-xs-12 control-label">Name</div>
                        <div className="col-xs-12">
                          <input
                            type="text"
                            name="title"
                            value={map_properties.title || ''}
                            onChange={this.handleChange}
                            placeholder="Map Name"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xs-12 control-label">Youtube Video (Must be an embed link)</div>
                        <div className="col-xs-12 mb-sm">
                          <input
                            type="text"
                            name="mapYoutubeVideo"
                            value={map_properties.mapYoutubeVideo || ''}
                            onChange={this.handleChange}
                            placeholder="Youtube Video Link"
                            className="form-control"
                          />
                        </div>
                        {map_properties.mapYoutubeVideo && (
                          <div className="col-xs-12">
                            <iframe width="100%" height="315" src={map_properties.mapYoutubeVideo} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                          </div>
                        )}
                      </div>
                    </div>
                    <p className="title">Map Type (Required)</p>
                    <div className="row mb-sm">
                      <div className="col-xs-12">
                        <Select
                          defaultValue={{ label: 'Hail', value: 'Hail' }}
                          options={['Hail', 'Wind'].map(value => ({ label: value, value }))}
                          placeholder="Select Map Type"
                          onChange={event => this.handleMapTypeSelect(event && event.value)}
                          value={map_properties.mapType}
                        />
                      </div>
                    </div>
                    <p className="title">Event Tags (at least one)</p>
                    <div className="row mb-sm">
                      <div className="col-xs-12">
                        <Select
                          multi
                          options={['Hail', 'Wind', 'Hurricane', 'Tornado', 'Flood'].map(value => ({ label: value, value }))}
                          placeholder="Select Weather Event Features"
                          onChange={event => this.handleEventTagsSelect(event && event.map(({ value }) => value))}
                          value={map_properties.eventTags || []}
                        />
                      </div>
                    </div>
                    {map_properties.mapType && <div className="animated fadeIn">
                      <p className="title">Regions Affected</p>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">States</div>
                          <div className="col-xs-12">
                            <Select
                              options={states_list}
                              placeholder='Select States'
                              multi
                              onChange={this.handleStateSelect}
                              value={this.state.properties.states}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Cities</div>
                          <div className="col-xs-12">
                            <Select
                              options={cities_list}
                              placeholder='Select Cities'
                              multi
                              onChange={this.handleCitySelect}
                              value={this.state.properties.cities}
                            />
                          </div>
                        </div>
                      </div>
                      <hr className="separator" />
                      <p className="title">Product Sale Info</p>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Is Free?
                            <Checkbox
                              id='map-creator-is-free-check-box'
                              name='free'
                              className='form-control'
                              onChange={this.handleChange}
                              checked={map_properties.free == true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Price (in cents)</div>
                            <div className="col-xs-12">
                              <input
                                type="text"
                                name="price"
                                value={map_properties.price || ''}
                                onChange={this.handleChange}
                                placeholder="Price"
                                className="form-control"
                              />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Description</div>
                          <div className="col-xs-12">
                            <textarea
                              className="form-control"
                              value={map_properties.description || ''}
                              name='description'
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <hr className="separator" />
                      <p className="title">{map_properties.mapType} Stats</p>
                      {map_properties.mapType === 'Hail' && <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Max Hail Size</div>
                          <div className="col-xs-12">
                            <input
                              type="text"
                              className="form-control"
                              value={map_properties.max_hail_size || ''}
                              name='max_hail_size'
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>}
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Max Wind Speed</div>
                          <div className="col-xs-12 col-md-8">
                            <input
                              type="text"
                              className="form-control"
                              value={map_properties.max_wind_speed || ''}
                              name='max_wind_speed'
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="col-xs-12 col-md-4">
                            <select
                              onChange={this.handleChange}
                              name="max_wind_speed_direction"
                              className="form-control"
                              value={map_properties.max_wind_speed_direction || ''}
                              >
                              <option value={""}>Select One</option>
                              <option value={"N"}>N</option>
                              <option value={"S"}>S</option>
                              <option value={"E"}>E</option>
                              <option value={"W"}>W</option>
                              <option value={"NW"}>NW</option>
                              <option value={"NE"}>NE</option>
                              <option value={"SW"}>SW</option>
                              <option value={"SE"}>SE</option>
                            </select>
                          </div>
                          <div className="col-xs-12">
                          {map_properties.max_wind_speed_direction} {map_properties.max_wind_speed} mph
                          </div>
                        </div>
                      </div>
                      {map_properties.mapType === 'Hail' &&<div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Hail Duration (In Minutes)</div>
                          <div className="col-xs-12">
                            <input
                              type="text"
                              className="form-control"
                              value={map_properties.hail_duration || ''}
                              name='hail_duration'
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>}
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">House Count</div>
                          <div className="col-xs-12">
                            <input
                              type="text"
                              className="form-control"
                              value={map_properties.max_house_count || ''}
                              name='max_house_count'
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Star Level</div>
                          <div className="col-xs-12">
                            <select
                              className="form-control"
                              name='star_level'
                              value={map_properties.star_level || ''}
                              onChange={this.handleChange}
                              >
                              <option value={1}>1 Star</option>
                              <option value={2}>2 Star</option>
                              <option value={3}>3 Star</option>
                              <option value={4}>4 Star</option>
                              <option value={5}>5 Star</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <hr className="separator" />
                      <p className="title">Publish Details</p>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Storm Date</div>
                          <div className="col-xs-12">
                            <DateTimeField
                              onChange={this.handleStormDateChange}
                              dateTime={moment(map_properties.storm_date).format('MM/DD/YYYY')}
                              format={'MM/DD/YYYY'}
                              inputFormat={'MM/DD/YYYY'}
                              showToday={true}
                              viewMode='days'
                            />
                            {errors.storm_date ? (
                              <div className="alert alert-danger mt-sm">Please enter a valid date.</div>
                            ) : (
                              <h6>{new Date(map_properties.storm_date).toISOString()}</h6>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-xs-12 control-label">Publish On</div>
                          <div className="col-xs-12">
                            <DateTimeField
                              onChange={this.handlePublishDateChange}
                              dateTime={moment(map_properties.publish_date).format('MM/DD/YYYY')}
                              format={'MM/DD/YYYY'}
                              inputFormat={'MM/DD/YYYY'}
                              showToday={true}
                              viewMode='days'
                            />
                            {errors.publish_date ? (
                              <div className="alert alert-danger mt-sm">Please enter a valid date.</div>
                            ) : (
                              <h6>{new Date(map_properties.publish_date).toISOString()}</h6>
                            )}
                          </div>
                      </div>
                    </div>
                  </div>}
                </form>
              </div>
            </div>
          </div>
          <div className='panel-footer mb-none'>
            <div className='row'>
              <div className='col-xs-12 col-md-6'>
                <div
                  onClick={this.props.cancelEditMap}
                  className='btn btn-block btn-default'
                  >
                  Cancel
                </div>
              </div>
              <div className='col-xs-12 col-md-6'>
                <div
                  onClick={this.handleSave}
                  className='btn btn-block btn-success'
                  >
                  Save
                </div>
              </div>
            </div>
            <div className='row mt-sm'>
              <div className='col-xs-12 col-md-12'>
                <span>
                  <ToggleSwitch
                    on_condition={this.state.properties.finished}
                    onClick={() => this.setState({ properties: { ...this.state.properties, finished: !this.state.properties.finished } })}
                  />
                  {'  '}Finished
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }
    else {
      return <div />
    }
  }
}

export default mapCreatorConnect(MapForm);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-form.js